import { Injectable } from '@angular/core';
import { CanDeactivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";

export interface ComponentCanDeactivateDirtyValidation {
    canDeactivate(): boolean | Observable<boolean>;
    finalize(): Promise<void>;
}

@Injectable()
export class CanDeactivateDirtyValidationGuard implements CanDeactivate<ComponentCanDeactivateDirtyValidation> {

    constructor(public dialog: MatDialog, private router: Router) {

    }

    async canDeactivate(component: ComponentCanDeactivateDirtyValidation, route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let can = component.canDeactivate();
        if (!can) {
            let model = { message: "Changes will be lost. Do you wish to continue?", buttonOne: "Yes", buttonTwo: "No" }
            const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: model, disableClose: true, width: "330px", panelClass: "crms-cd" });
            return await dialogRef.afterClosed().toPromise().then((res) => { if (res) { return true; } return false; });
        } else return true;
    }
}